<template>
<div>
  <b-row class="mt-4">
      <b-col cols="5">JOB #</b-col>
      <b-col>{{site.jobNumber}}</b-col>
    </b-row>
    <b-row class="">
      <b-col cols="5">SITE</b-col>
      <b-col>{{site.name}}</b-col>
    </b-row>
    <b-row class="">
      <b-col cols="5">ADDRESS</b-col>
      <b-col>{{street}}</b-col>
    </b-row>
    <b-row class="">
      <b-col cols="5">CITY / TOWN</b-col>
      <b-col>{{city}}</b-col>
    </b-row>
    <b-row class="">
      <b-col cols="5">SITE CONTACT</b-col>
      <b-col>{{foreperson}}</b-col>
    </b-row>
    <b-row>
      <b-col cols="5">SITE MOBILE NO</b-col>
      <b-col>
        <a :href="`tel:${site.forepersonMobile}`">{{ site.forepersonMobile }}</a>
      </b-col>
    </b-row>
    <b-row class="">
      <b-col cols="5">CONTRACT MGR</b-col>
      <b-col>{{contractManager}}</b-col>
    </b-row>
    <!--! Added here -->
    <b-row class="">
      <b-col>SITE LOCATION MAP</b-col>
    </b-row>
    <b-row class="section-map" v-if="latLngToObject(site.latLng)">
      <b-col class="d-flex align-items-center justify-content-center">
        <GmapMap
          :center="latLngToObject(site.latLng)"
          :zoom="15"
          map-type-id="terrain"
          style="width: 100%; height: 300px"
        >
          <GmapMarker
            :position="latLngToObject(site.latLng)"
            :clickable="true"
            :draggable="false"
            :title="site.name"
          />
        </GmapMap>
      </b-col>
    </b-row>
</div>
</template>

<style lang="scss">
  ul {
    padding-bottom: 0px;
    margin-bottom: 1px;
  }
</style>

<script>

import emailAddressTranslation from '@/lib/email-address-translation';

export default {
  name: 'BasicSiteDetails',
  props: {
    site: Object,
  },
  computed: {
    street() {
      // TODO: use the city field when the database is updated
      if (this.site.address) {
        return this.site.address.split(/[,\n]/).filter((val) => val !== this.city && val.trim().toLowerCase() !== 'new zealand').join(', ');
      }

      return this.site.address;
    },
    city() {
      // TODO: use the city field when the database is updated
      if (this.site.address) {
        return this.site.address.split(/[,\n]/).reverse().find((val) => val.trim().toLowerCase() !== 'new zealand');
      }

      return '';
    },
    foreperson() {
      if (this.site.forepersonUsername) {
        return emailAddressTranslation(this.site.forepersonUsername);
      }
      return '';
    },
    contractManager() {
      if (this.site.ownerUsername) {
        return emailAddressTranslation(this.site.ownerUsername);
      }
      return '';
    },
  },
  methods: {
    latLngToObject(latLng) {
      if (!latLng || latLng.trim().length === 0) return null;
      const parts = latLng.split(/,{1}\s{0,1}/g);
      return {
        lat: parseFloat(parts[0]),
        lng: parseFloat(parts[1]),
      };
    },
  },
};
</script>
